import Vue from 'vue';
import moment from 'moment';
import VueMoment from 'vue-moment';

moment.defaultFormat = 'DD.MM.YYYY HH:mm';

moment.locale('de', {
	relativeTime: {
		future: 'in %s',
		past: 'Vor %s',
		s: 'ein paar Sekunden',
		ss: '%d Sekunden',
		m: 'eine Minute',
		mm: '%d Minuten',
		h: 'eine Stunde',
		hh: '%d Stunden',
		d: 'ein Tag',
		dd: '%d Tage',
		M: 'ein Monat',
		MM: '%d Monate',
		y: 'ein Jahr',
		yy: '%d Jahre',
	},
});

Vue.use(VueMoment, { moment });
